import portalApiConfig from './api';
import request from './request';

const portalReq = {};

for (const key in portalApiConfig) {
  if (portalApiConfig.hasOwnProperty(key)) {
    portalReq[key] = (options) => {
      return request(options, portalApiConfig[key]);
    };
  }
}

export default portalReq;
